import React, { ReactNode } from 'react';
import { SpriteImage } from '../../SpriteImage/SpriteImage';
import styles from './inputerror.module.scss';

interface IInputErrorProps {
    children: ReactNode;
}

export const InputError = (props: IInputErrorProps): JSX.Element => {
    return (
        <div className={styles.inputError} role="alert">
            <SpriteImage className={styles.alertIcon} />
            <div>{props.children}</div>
        </div>
    );
};
